import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { APPLICATION } from 'sh-www/models/application';
import BuyerOnlyRouteMixin from 'sh-www/mixins/buyer-only-route-mixin';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class ProjectsCompleteRoute extends Route.extend(BuyerOnlyRouteMixin) {
  /**
   * State manager for this route
   * @type {Service}
   */
  @service('commands/company-commands') companyCommandService;
  @service('commands/company-team-commands') companyTeamCommandService;
  @service router;
  @service session;
  @service shData;
  @service('state-managers/routes/projects') stateManager;

  /** @inheritDoc */
  get controllerName() {
    return 'projects';
  }

  /** @inheritDoc */
  get templateName() {
    return 'projects';
  }

  /**
   * @inheritDoc
   */
  model() {
    this.controllerFor('projects').resetController();

    const { currentUser } = this.session;

    const applicationList = this.stateManager.loadApplicationDashboardList(APPLICATION.SIMPLE_STATUS.COMPLETE);
    const blackListedUsers = this.companyCommandService.loadBlockedUsersForCompany(currentUser.company.id);

    const companyTeams = this.companyTeamCommandService.loadCompanyTeams(currentUser.company.id, [
      'company-team-memberships.company-membership.user',
    ]);
    const companyWithMembers = this.companyCommandService.loadCompany(currentUser.company.id, [
      'company-memberships.user',
      'company-memberships.company-team-memberships',
    ]);

    return Promise.all([applicationList, blackListedUsers, companyTeams, companyWithMembers]).then(([applicationList, blackListedUsers, companyTeams, companyWithMembers]) => {
      this.shData.pushResponseToStore(companyTeams);

      return {
        applicationList,
        blackListedUsers,
        companyTeams: this.shData.getModelArrayFromResponse(companyTeams, 'companyTeam'),
        companyMemberships: companyWithMembers.companyMemberships.toArray(),
      };
    });
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/projects/completed/');
  }

  /**
   * @inheritDoc
   */
  _redirectUnauthorizedUser() {
    this.router.replaceWith('projects');
  }
}

export default ProjectsCompleteRoute;
